export const ApiUploadSpaceIcon = Symbol('ApiUploadSpaceIcon');
